import React from "react";
import classnames from "classnames";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Label,
  FormGroup,
  InputGroup,
  Form,
  Input,
} from "reactstrap";
import Select from "react-select";
import { ToastContainer } from "react-toastify";

/** The setting being typed into the Add form. */
type NewSetting = {
  variable?: string;
  type?: string;
  value?: string;
  complextype?: string;
};

/** One choice of the type select. */
type TypeOption = { label: string; value: string };

export type AddSiteConfigurationsViewProps = {
  current?: string;
  newSetting: NewSetting;
  dropdownList: TypeOption[];
  onChangeSettingRequired: React.ChangeEventHandler<HTMLInputElement>;
  onChangeSettingsOptional: React.ChangeEventHandler<HTMLInputElement>;
  onChangeOptions: (opt: TypeOption | null, name: string) => void;
  onClickAddSettings: () => void;
  canSubmit?: boolean;
};

const AddSiteConfigurationsView = ({
  current,
  newSetting,
  dropdownList,
  onChangeSettingRequired,
  onChangeSettingsOptional,
  onChangeOptions,
  onClickAddSettings,
  canSubmit,
}: AddSiteConfigurationsViewProps) => {
  return (
    <>
      <div className="rna-wrapper">
        <ToastContainer />
      </div>

      <Card>
        <CardHeader className="text-center">
          <h3 className="mb-0">Add Site Configurations for {current}</h3>
        </CardHeader>

        <CardBody className="ml-5">
          {/* Settings Required */}
          <Form>
            {/* Setting Name */}
            <FormGroup className="row">
              <Label className="form-control-label" md="2">
                Setting Name <small style={{ color: "red" }}>*</small>
              </Label>
              <Col md="7">
                <InputGroup className={classnames("input-group-merge")}>
                  <Input
                    type="text"
                    name="variable"
                    value={newSetting.variable || ""}
                    onChange={onChangeSettingRequired}
                    required
                  />
                </InputGroup>
              </Col>
            </FormGroup>

            {/* Setting Value */}
            <FormGroup className="row">
              <Label className="form-control-label" md="2">
                Setting Value
              </Label>
              <Col md="7">
                <Input
                  type="text"
                  name="value"
                  value={newSetting.value || ""}
                  onChange={onChangeSettingRequired}
                  required
                />
              </Col>
            </FormGroup>
          </Form>

          {/* Settings Optionals */}
          <Form>
            {/* Type */}
            <FormGroup className="row">
              <Label className="form-control-label" md="2">
                Type
              </Label>
              <Col md="7">
                <Select
                  options={dropdownList}
                  value={
                    dropdownList.find((o) => o.value === newSetting.type) ||
                    dropdownList[0]
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  name="type"
                  onChange={(opt) => onChangeOptions(opt, "type")}
                />
              </Col>
            </FormGroup>

            {/* Complex Type */}
            <FormGroup className="row">
              <Label className="form-control-label" md="2">
                Complex Type
              </Label>
              <Col md="7">
                <Input
                  type="text"
                  name="complextype"
                  value={newSetting.complextype || ""}
                  onChange={onChangeSettingsOptional}
                />
              </Col>
            </FormGroup>
          </Form>

          {canSubmit ? (
            <FormGroup className="row">
              <Col className="text-right" lg="9">
                <Button
                  className="my-4"
                  color="success"
                  onClick={onClickAddSettings}
                  type="button"
                >
                  Add Settings
                </Button>
              </Col>
            </FormGroup>
          ) : null}
        </CardBody>
      </Card>
    </>
  );
};

export default AddSiteConfigurationsView;
